<template>
  <div class="references-container">
    <div class="references-title">
      <h1>NOS RÉFÉRENCES</h1>
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/references">Références</a>
      </div>
    </div>
    
    <div class="supracare-description">
      <link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&family=Open+Sans:wght@300;400;600&display=swap" rel="stylesheet">
      <!-- Section ajoutée -->
      <div class="content twocolums clearfix">
        <div id="c255" class="frame frame-default frame-type-textmedia frame-layout-0">
          <a id="c849"></a>
          <div class="csc-header csc-header-n1">
            <h1>Nos clients de référence (extrait)</h1>
          </div>
          <div class="ce-textpic ce-right ce-intext">
            <div class="ce-bodytext">
              <p><b>Clients de référence de Supracare </b></p>
                 <p>
                 Supracare collabore avec de nombreux laboratoires et établissements de santé à travers le Maroc.
               </p>
            </div>
          </div>
        </div>

        <div id="c256" class="frame frame-default frame-type-list frame-layout-0">
          <a id="c850"></a>
          <div class="referenzenOuterWrapper clearfix">
            <div class="referenzenWrapper">
              <img alt="Almirall" src="/fileadmin/user_upload/bilder/referenzen/Almirall.jpg" width="180" height="51">
            </div>
            <div class="referenzenWrapper">
              <img alt="Apollinaris" src="/fileadmin/user_upload/bilder/referenzen/Apollinaris.jpg" width="180" height="96">
            </div>
            <div class="referenzenWrapper">
              <img alt="applichem" src="/fileadmin/user_upload/bilder/referenzen/applichem.jpg" width="180" height="53">
            </div>
            <div class="referenzenWrapper">
              <img alt="BAM" src="/fileadmin/user_upload/bilder/referenzen/BAM.jpg" width="180" height="121">
            </div>
            <div class="referenzenWrapper">
              <img alt="baxter" src="/fileadmin/user_upload/bilder/referenzen/baxter.jpg" width="180" height="59">
            </div>
            <div class="referenzenWrapper">
              <img alt="Bayer" src="/fileadmin/user_upload/bilder/referenzen/Bayer.jpg" width="180" height="81">
            </div>
            <div class="referenzenWrapper">
              <img alt="beckman" src="/fileadmin/user_upload/bilder/referenzen/beckman.jpg" width="180" height="81">
            </div>
            <div class="referenzenWrapper">
              <img alt="Biohit" src="/fileadmin/user_upload/bilder/referenzen/Biohit.jpg" width="180" height="85">
            </div>
          </div>
          <div class="referenzenTextClear">&nbsp;</div>
          <div class="referenzenItemTextWrapper clearfix"></div>
        </div>
      </div>
      <!-- Fin de la section ajoutée -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReferencesPage',
};
</script>

<style scoped>
.references-container {
  padding: 0px 0px;
  background-color: #f9f9f9;
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.references-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: -1;
}

.references-title {
  position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/img6.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77);
  padding: 150px 300px;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  z-index: 1;
}

.breadcrumb {
  font-size: 12px;
  color: #555;
  margin-top: 20px;
}

.breadcrumb a {
  color: #0c0c0c;
  text-decoration: none;
  font-weight: bold;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.supracare-description {
  padding: 20px 200px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-top: 0px;
  font-family: 'Open Sans', sans-serif;
}

.supracare-description h2 {
  color: #4c4a4d;
  font-size: 1.8rem;
  margin-bottom: 15px;
  font-family: 'Merriweather', serif;
}

.supracare-description p {
  font-size: 1.1rem;
  line-height: 1.75;
  color: #333;
  margin-bottom: 20px;
  font-family: 'Open Sans', sans-serif;
}

/* Styles pour les clients de référence */
.content {
  margin-top: 30px;
}

.referenzWrapper {
  display: inline-block;
  margin: 10px;
}

@media (max-width: 768px) {
  .references-title {
    font-size: 2rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}

/* Responsive pour les petits écrans */
@media (max-width: 768px) {
  .references-title {
    font-size: clamp(1.5rem, 5vw, 1rem);
    padding: 100px 0px;
  }

  .breadcrumb {
    font-size: 0.9rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}
</style>
